import React, { useEffect, useCallback, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';
import ConversationRateTab from './components/ConversationRateTab';
import UserAgeGroupTab from './components/UserAgeGroupTab';

const tabs = [
    { id: 'conversion-rate', label: 'Conversation Rate' },
    { id: 'user-age-group', label: 'User Age Group' },
];

const Reports = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get('tab') || 'conversion-rate';

    const handleTabChange = (tabId) => {
        setSearchParams({ tab: tabId });
    };

    useEffect(() => {
        if (!searchParams.get('tab')) {
            setSearchParams({ tab: 'conversion-rate' }, { replace: true });
        }
    }, [searchParams, setSearchParams]);

    const renderTabContent = () => {
        switch (activeTab) {
            case 'conversion-rate':
                return <ConversationRateTab />;
            case 'user-age-group':
                return <UserAgeGroupTab />;
            default:
                return <ConversationRateTab />;
        }
    };

    return (
        <React.Fragment>
            <Helmet>
                <title>Ove | Reports</title>
            </Helmet>
            <div className="page-wrapper subscription-container">
                <div className="content container-fluid">
                    <div className="admin-wrapper subscription-table analytics-wrapper">
                        <div className="page-header mb-3">
                            <div className="w-100 d-flex justify-content-between align-items-center flex-wrap gap-2">
                                <h1 className="page-title mb-0">Reports</h1>
                            </div>
                        </div>

                        <div className="subscription-tabs mb-3 d-flex flex-wrap gap-2">
                            {tabs.map((tab) => (
                                <button
                                    type="button"
                                    key={tab.id}
                                    className={`subscription-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                                    onClick={() => handleTabChange(tab.id)}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <div>
                                    <div className="mt-2">
                                        {renderTabContent()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Reports;
